/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M459.126 294.8H34.55c-19.072 0-34.56-15.462-34.56-34.56 0-19.072 15.488-34.534 34.56-34.534h424.576c19.072 0 34.56 15.462 34.56 34.534 0 19.098-15.488 34.56-34.56 34.56"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconMinus = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconMinus.defaultProps = {
  theme,
};
IconMinus.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconMinus.displayName = 'IconMinus';
export { IconMinus };
